import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "relative rounded-md bg-white py-1.5 pl-3 pr-1.5 shadow-sm ring-1 ring-inset ring-gray-300 w-full group/filter-box" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "font-normal mb-1" }
const _hoisted_4 = { class: "text-sm flex items-center" }
const _hoisted_5 = { class: "mr-3 text-gray-400" }
const _hoisted_6 = { class: "flex py-0.5 px-4 border rounded-full max-w-60 cursor-pointer truncate border-gray-300" }
const _hoisted_7 = {
  key: 0,
  class: "flex justify-between"
}
const _hoisted_8 = { class: "text-gray-500 max-w-[160px] overflow-hidden whitespace-nowrap text-ellipsis mr-1" }
const _hoisted_9 = { class: "text-gray-500" }
const _hoisted_10 = { key: 1 }

import { XMarkIcon } from "@heroicons/vue/24/outline";
import debounce from "lodash.debounce";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { HierarchyTagStore } from "shared/types/HierarchyTag";
import LocationFilter from "@/components/process_filters/LocationFilter.vue";
import { ReportLocationFilter } from "@/types/reports/filters";


export default /*#__PURE__*/_defineComponent({
  __name: 'ReportLocationFilterField',
  props: {
    filter: {},
    hierarchyTags: {}
  },
  emits: ["change"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const { t } = useI18n();

const populateSectionMask = (id: string) => props.hierarchyTags.find((tag) => tag._id === id);

const hierarchyTagsForLocationFilter = computed(() =>
  props.hierarchyTags.filter((tag) => tag.type !== "component"),
);

const handleLocationFilterRemoveFilter = () => {
  onChangeHandler([]);
};

const debouncedEmitChange = debounce((newFilter: ReportLocationFilter) => {
  emit("change", newFilter);
}, 300);

const onChangeHandler = (filters: ReportLocationFilter) => {
  debouncedEmitChange(filters);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)("analytics.reports.location")), 1),
      _createElementVNode("div", {
        class: "cursor-pointer p-1 invisible group-hover/filter-box:visible rounded-md hover:bg-red-200 active:bg-red-300 transition-colors duration-100",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (handleLocationFilterRemoveFilter()))
      }, [
        _createVNode(_unref(XMarkIcon), {
          class: "h-4 w-4 select-none",
          "aria-hidden": "true"
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)("analytics.reports.is")), 1),
      _createVNode(LocationFilter, {
        class: "mt-2 lg:mt-0 flex-1",
        onChange: onChangeHandler,
        selected: _ctx.filter,
        hierarchyTags: hierarchyTagsForLocationFilter.value,
        popoverClass: "translate-x-0 lg:translate-x-0 xl:-translate-x-8 md:right-auto mt-3"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            (Object.values(_ctx.filter).some((mask) => mask.length))
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.filter.map((tagId) => populateSectionMask(tagId)?.name).join(", ")), 1),
                  _createElementVNode("span", _hoisted_9, " (" + _toDisplayString(_ctx.filter.length) + ") ", 1)
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_10, "..." + _toDisplayString(_unref(t)("analytics.reports.select_values")), 1))
          ])
        ]),
        _: 1
      }, 8, ["selected", "hierarchyTags"])
    ])
  ]))
}
}

})